import { useQuery } from '@tanstack/react-query';

import REACT_QUERY_KEYS_REVIEWS_INSIGHTS from '../../TrendLineChart/constants/reactQueryKeysReviewsInsights';
import getSankeyChartData from '../services';

// get

const useSankeyChartData = ({ request1, request2 }) =>
  useQuery([REACT_QUERY_KEYS_REVIEWS_INSIGHTS.reviewsSankeyChart, request1, request2], () =>
    getSankeyChartData({ request1, request2 })
  );

export default useSankeyChartData;
